import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import ajaxProject from "../../util/remote/ajaxProject";

export default function ProjectCard() {
  const [lowPriorityNumber, setLowPriorityNumber] = useState(false);

  const getLowPriorityProjects = async () => {
    const server_response = await ajaxProject.fetchLowProjectNumber();

    if (server_response.status === "OK") {
      setLowPriorityNumber(server_response.details);
    } else {
      setLowPriorityNumber("404");
    }
  };

  useEffect(() => {
    getLowPriorityProjects();
  }, []);

  return (
    <div
      className="icon-box bg-color-6 d-block mt-4 mb-3"
      style={{
        background: "#E6FAF4",
        width: "25%",
        padding: "20px",
        margin: "15px 0 !important",
      }}>
      <div className="content text-center color-6">
        <h5 className="title-box fs-17 font-w500">Low Priority Projects</h5>
        <div
          className="excellencetheme-counter fs-18 font-wb"
          style={{ fontWeight: "bold", color: "#35CF96" }}>
          <span
            className="number"
            data-from="0"
            data-to="309"
            data-speed="2500"
            data-inviewport="yes">
            <CountUp
              start={0}
              end={lowPriorityNumber ? lowPriorityNumber.total_p : "..."}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
